import React from 'react';
import { View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import { Text } from '@/ui';
import { ChevronRight } from '@/ui/icons/chevron-right';
import { MenuItem } from '@/ui/menu-item';

interface UsedTeslaPromptProps {
  onClick: (isTeslaPro: boolean) => void;
}

export default function UsedTeslaPrompt({ onClick }: UsedTeslaPromptProps) {
  const { styles, theme } = useStyles(stylesheet);

  return (
    <View style={styles.container}>
      <View>
        <Text type="title1">Have you ever driven a Tesla before?</Text>

        <Text type="bodyRegular" style={{ color: theme.colors.text.secondary }}>
          You'll receive all the information you need for your rental once you
          complete check-in.
        </Text>
      </View>

      <View style={{ gap: 8 }}>
        <MenuItem
          rightIcon={<ChevronRight />}
          rightIconFillColor={theme.colors.icon.color}
          tx="tutorial.usedTeslaFirstTime"
          onPress={() => {
            onClick(false);
          }}
          style={{
            width: '100%',
            borderWidth: 1,
            borderColor: theme.colors.card.default.borderColor,
          }}
        />

        <MenuItem
          rightIcon={<ChevronRight />}
          rightIconFillColor={theme.colors.icon.color}
          tx="tutorial.usedTeslaOnceOrTwice"
          onPress={() => {
            onClick(false);
          }}
          style={{
            width: '100%',
            borderWidth: 1,
            borderColor: theme.colors.card.default.borderColor,
          }}
        />

        <MenuItem
          rightIcon={<ChevronRight />}
          rightIconFillColor={theme.colors.icon.color}
          tx="tutorial.usedTeslaManyTimes"
          onPress={() => {
            onClick(true);
          }}
          style={{
            width: '100%',
            borderWidth: 1,
            borderColor: theme.colors.card.default.borderColor,
          }}
        />
      </View>
    </View>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  container: {
    flexGrow: 1,
    gap: 24,
    backgroundColor: theme.colors.background_1,
    justifyContent: 'space-between',
  },
}));
